/**
 * OffenseSection - Offense/charge text field
 *
 * Hard-capped at the database column size (LARGE_BOND_FIELD_LIMITS.OFFENSE)
 * with a live counter, because this is the field agents paste long court
 * text into and the one that used to overflow on submit.
 */

import { OathInput } from '../../../shared/OathUI';
import { LARGE_BOND_FIELD_LIMITS, fieldTooLongMessage } from '../shared/largeBondConstants';

const LIMIT = LARGE_BOND_FIELD_LIMITS.OFFENSE;

const OffenseSection = ({ formState, dispatch, disabled }) => {
  const length = (formState.offense || '').length;
  const overLimit = length > LIMIT; // only reachable via prefilled edit data
  const nearLimit = !overLimit && length >= LIMIT - 25;

  return (
    <div>
      <h4 className="font-medium text-gray-900 dark:text-white mb-3">Charges</h4>
      <div className="max-w-md">
        <OathInput
          label="Offense / Charge"
          value={formState.offense}
          onChange={(val) => dispatch({ type: 'SET_FIELD', field: 'offense', value: val })}
          placeholder="Charge description"
          required
          disabled={disabled}
          maxLength={LIMIT}
          error={overLimit ? fieldTooLongMessage('Charges / Offense description', length, LIMIT) : undefined}
          helperText={
            <span className={nearLimit ? 'text-amber-600 dark:text-amber-400 font-medium' : undefined}>
              {length} / {LIMIT} characters
            </span>
          }
        />
      </div>
    </div>
  );
};

export default OffenseSection;
